import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import CookbookTagMealsContainer from './CookbookTagMealsContainer';
import {
  useTimestamp,
  CookbookMealListConnectorApollo,
  AddFavoriteCookbookMealConnectorApollo,
  RemoveFavoriteCookbookMealConnectorApollo,
  MealsSearchCriteriaInputType,
} from '@front-activerse/common-components';

const buildSearchCriteria = (tagType: string, tagId: number): MealsSearchCriteriaInputType => {
  switch (tagType) {
    case 'custom':
      return { customTags: [tagId] };
    case 'mealType':
      return { mealTypeTags: [tagId] };
    case 'dietType':
      return { dietTypeTags: [tagId] };
    default:
      return { customTags: [tagId] };
  }
};

export const CookbookTagMealsPage: React.FC = () => {
  const { timestamp1 } = useTimestamp();
  const { tagType, tagId } = useParams();
  const [searchParams] = useSearchParams();
  const tagName = searchParams.get('name') || '';

  const searchCriteria = buildSearchCriteria(tagType || 'custom', tagId ? +tagId : 0);

  return (
    <CookbookMealListConnectorApollo searchCriteria={searchCriteria}>
      {(cookbookMealListData) => (
        <AddFavoriteCookbookMealConnectorApollo>
          {({ addCookbookMealToFavorite }) => (
            <RemoveFavoriteCookbookMealConnectorApollo>
              {({ removeCookbookMealFromFavorites }) => (
                <CookbookTagMealsContainer
                  tagName={tagName}
                  tagType={tagType || 'custom'}
                  tagId={tagId || '0'}
                  {...cookbookMealListData}
                  addToFavorites={addCookbookMealToFavorite}
                  removeFromFavorites={removeCookbookMealFromFavorites}
                  key={timestamp1}
                />
              )}
            </RemoveFavoriteCookbookMealConnectorApollo>
          )}
        </AddFavoriteCookbookMealConnectorApollo>
      )}
    </CookbookMealListConnectorApollo>
  );
};

export default CookbookTagMealsPage;
